
export const client_id = '899835117399-4g4k1e1p59e4kshkvb7fihgs5346647h.apps.googleusercontent.com';



//231205094307-jq444u8p88ug2esj937f934ub3b4eiqu.apps.googleusercontent.com
export const client_id_miniso = '675110148186-gbmquuuo4g70crvpmua0joq7om1fvkkk.apps.googleusercontent.com';

export const id_face_old = '229254892779739'; //'933422631180070'; 

export const id_face = '438209150718970';

const nodeEnv='PRD';

export const proxyServer= nodeEnv==='PRD'?'https://minisolove.miniso.com.mx/':'http://localhost:8000/';

//export const proxyServer='http://192.168.100.18/';

//export const proxyServer='http://localhost:8000/'; //localService